var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pricing-tariffs-list pricing-tariffs-list--odd"},[_vm._l((_vm.tariffs),function(tariff){return [_c('li',{staticClass:"pricing-tariffs-list__item"},[_c('PricingTariffsCard',{attrs:{"currency":_vm.currency,"lang":_vm.lang,"tariff":tariff}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }